var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-headful',{attrs:{"title":"Випускний іспит Kiosk"}}),_c('final-exam-kiosk-index')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }